module.exports = __webpack_public_path__ + "assets/img/lock.8b31e9de.svg";